import React, { PureComponent } from 'react'
import logoPNG from "../img/2026_belarus.png";
import '../Reservation.css';

export class Logo extends PureComponent {
  render() {
    return (
        <div id='logo'>
            <img style={{width:500}} id='logoSVG' src={ logoPNG }></img>
            <h1>IIIAHC Check In</h1>
        </div>
    )
  }
}

export default Logo
